import type * as ents from '@attain-apps/entities'
import type * as store from '@attain-apps/fe/web/main/lib/store'

import type { getActionsConfig } from './actions'
import type { State } from './state'

export type Feature = store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
>

/**
 * Selectors for space warning state.
 */
export class Selectors {
  /** Selector indicating if warnings are being loaded from the backend */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isLoading

  /** Selector indicating if there was an error while fetching warnings */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  /** Lookup map of all warning messages keyed by code */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly lookup

  /** Indicates there is at least one warning for the current entity */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly hasWarnings

  /** Returns a selector for the message associated with the given warning code */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly getMessage

  constructor(feature: Feature) {
    this.error = feature.state.project(state => state.error)
    this.isLoading = feature.state.project(state => state.isLoading)
    this.lookup = feature.state.project(state => state.lookup)
    this.hasWarnings = this.lookup.project(
      lookup => Object.keys(lookup ?? {}).length > 0,
    )
    this.getMessage = feature.createSelectorMethod(
      (code: ents.extra.space.Warning.Code) =>
        feature.state.project(state => state.lookup?.[code]),
    )
  }
}
